class TypeChecker {
  static isNumber = (target) => {
    return typeof target === 'number'
  }

  static isString = (target) => {
    return typeof target === 'string'
  }

  static isFunction = (target) => {
    return typeof target === 'function'
  }

  static isObject = (target) => {
    return Object.prototype.toString.call(target) === '[object Object]'
  }

  static isArray = (target) => {
    return Object.prototype.toString.call(target) === '[object Array]'
  }

  static isDate = (target) => {
    return Object.prototype.toString.call(target) === '[object Date]'
  }

  static isRegExp = (target) => {
    return Object.prototype.toString.call(target) === '[object RegExp]'
  }

  static isBoolean = (target) => {
    return Object.prototype.toString.call(target) === '[object Boolean]'
  }

  static isFile = (target) => {
    return Object.prototype.toString.call(target) === '[object File]'
  }

  static isNavigator = (target) => {
    return Object.prototype.toString.call(target) === '[object Navigator]'
  }

  static isUndefined = (target) => {
    return typeof target === 'undefined'
  }

  static isNull = (target) => {
    return target === null
  }
}

export { TypeChecker }

window.TypeChecker = TypeChecker
